import React from 'react'
import { Card } from 'components'
import { Spinner } from 'controls'

const Loading = () => (
  <Card rounded style={{ margin: 0, padding: '0.5rem' }}>
    <div style={{ display: 'flex', justifyContent: 'center' }}>
      <Spinner size={25} thickness={4} />
    </div>
  </Card>
)

export default Loading
